import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.75 1.5H9.375C9.34185 1.5 9.31005 1.48683 9.28661 1.46339C9.26317 1.43995 9.25 1.40815 9.25 1.375V0.5C9.25 0.367392 9.19732 0.240215 9.10355 0.146447C9.00979 0.0526784 8.88261 0 8.75 0C8.61739 0 8.49021 0.0526784 8.39645 0.146447C8.30268 0.240215 8.25 0.367392 8.25 0.5V2.875C8.25 2.97446 8.21049 3.06984 8.14017 3.14017C8.06984 3.21049 7.97446 3.25 7.875 3.25C7.77554 3.25 7.68016 3.21049 7.60984 3.14017C7.53951 3.06984 7.5 2.97446 7.5 2.875V1.75C7.5 1.6837 7.47366 1.62011 7.42678 1.57322C7.37989 1.52634 7.3163 1.5 7.25 1.5H4.125C4.09185 1.5 4.06005 1.48683 4.03661 1.46339C4.01317 1.43995 4 1.40815 4 1.375V0.5C4 0.367392 3.94732 0.240215 3.85355 0.146447C3.75979 0.0526784 3.63261 0 3.5 0C3.36739 0 3.24021 0.0526784 3.14645 0.146447C3.05268 0.240215 3 0.367392 3 0.5V2.875C3 2.97446 2.96049 3.06984 2.89017 3.14017C2.81984 3.21049 2.72446 3.25 2.625 3.25C2.52554 3.25 2.43016 3.21049 2.35983 3.14017C2.28951 3.06984 2.25 2.97446 2.25 2.875V1.75C2.25 1.6837 2.22366 1.62011 2.17678 1.57322C2.12989 1.52634 2.0663 1.5 2 1.5H1.25C0.984784 1.5 0.73043 1.60536 0.542893 1.79289C0.355357 1.98043 0.25 2.23478 0.25 2.5V11C0.25 11.2652 0.355357 11.5196 0.542893 11.7071C0.73043 11.8946 0.984784 12 1.25 12H10.75C11.0152 12 11.2696 11.8946 11.4571 11.7071C11.6446 11.5196 11.75 11.2652 11.75 11V2.5C11.75 2.23478 11.6446 1.98043 11.4571 1.79289C11.2696 1.60536 11.0152 1.5 10.75 1.5ZM10.5 11H1.5C1.4337 11 1.37011 10.9737 1.32322 10.9268C1.27634 10.8799 1.25 10.8163 1.25 10.75V4.75C1.25 4.6837 1.27634 4.62011 1.32322 4.57322C1.37011 4.52634 1.4337 4.5 1.5 4.5H10.5C10.5663 4.5 10.6299 4.52634 10.6768 4.57322C10.7237 4.62011 10.75 4.6837 10.75 4.75V10.75C10.75 10.8163 10.7237 10.8799 10.6768 10.9268C10.6299 10.9737 10.5663 11 10.5 11Z",
  fill: "#211F58"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'calendarIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "currentColor",
  },
  size: {
    type: Number as PropType<number>,
    default: 12,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: __props.size,
    height: __props.size,
    viewBox: `0 0 ${__props.size} ${__props.size}`,
    fill: "none"
  }, _hoisted_3, 8, _hoisted_1))
}
}

})